<template>
  <Button v-bind="$attrs" severity="secondary" size="small" @click="onClickMenuToggle">
    <i :class="menuButtonClass"></i>
  </Button>
  <Menu ref="menuPopover" popup :model="menuPopoverItems"></Menu>
</template>

<script setup>
import store from "./store.js";
import { ref, computed } from "vue";

let props = defineProps([
  "showingMenu",
  "deleteAllRecords",
  "deleteSelectedRecords",
  "deleteArchivedRecords"
]);

let menuPopover = ref(null);
let showingMenu = defineModel("showingMenu");
function onClickMenuToggle(event) {
  if (store.showAdvanced)
    menuPopover.value.toggle(event);
  else
    showingMenu.value = !showingMenu.value;
}

let menuButtonClass = computed(() => {
  return {
    'pi': true,
    'pi-ellipsis-h': store.showAdvanced,
    'pi-angle-double-left': !store.showAdvanced && showingMenu.value,
    'pi-angle-double-right': !store.showAdvanced && !showingMenu.value
  };
});

let menuPopoverItems = computed(() => {
  return [
    { label: "Toggle menu", command: () => showingMenu.value = !showingMenu.value },
    { label: "Download records database", command: () => window.location.href = "/data/records.db" },
    { label: "Delete all records", command: () => props.deleteAllRecords() },
    { label: "Delete selected records", command: () => props.deleteSelectedRecords() },
    { label: "Delete archived records", command: () => props.deleteArchivedRecords() }
  ];
});
</script>

